var _polygon, _line, _line2, _line3, _line4, _line5, _line6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,24 12,44.78460969082653 36,44.78460969082653 48,24 36,3.2153903091734723 12,3.2153903091734723",
    fill: "orange",
    transform: "rotate(90 24 24)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 24,
    x2: 18,
    y2: 24,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21,
    x2: 18,
    y2: 24,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 27,
    x2: 18,
    y2: 24,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 24,
    x2: 38,
    y2: 24,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 21,
    x2: 38,
    y2: 24,
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 27,
    x2: 38,
    y2: 24,
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 8,
    height: 12,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformer);
export default __webpack_public_path__ + "static/media/transformer.ee0a7c675833428716dabd0c0ad8375d.svg";
export { ForwardRef as ReactComponent };